<form id="form" [formGroup]="form" (ngSubmit)="submitForm()" *ngIf="form">
	<div class="row my-4">
		<div class="col-12 col-lg">
			<label for="statutInt" class="form-label fw-bold"
				>Type d'employé</label
			>
			<select
				required
				id="statutInt"
				class="form-select"
				name="statutInt"
				formControlName="statutInt"
				aria-label="Sélectionner un type"
				[ngClass]="{
					'is-invalid': statutInt.invalid,
					'is-valid': statutInt.dirty && statutInt.valid
				}"
				(change)="toggleEmployeeTypeSelected()"
			>
				<option [value]="EmployeeTypeEnum.INT">Interne</option>
				<option [value]="EmployeeTypeEnum.EXT">
					Externe
				</option>
			</select>
		</div>
	</div>

	<div class="row my-4">
		<div *ngIf="form.contains('firstName')" class="col-12 col-lg">
			<label for="firstName" class="form-label fw-bold">Prénom</label>
			<input
				autocomplete="off"
				required
				type="text"
				class="form-control"
				id="firstName"
				name="firstName"
				formControlName="firstName"
				[ngClass]="{
					'is-invalid': firstName.invalid,
					'is-valid': firstName.dirty && firstName.valid
				}"
			/>
			<div *ngIf="firstName.invalid" class="invalid-feedback">
				<span *ngIf="firstName.errors?.required">Un prénom est requis</span>
				<span *ngIf="firstName.errors?.maxlength"
					>Le prénom ne doit pas dépasser {{ MAX_NAME_CHAR }} caractères</span
				>
				<span *ngIf="firstName.errors?.pattern"
					>Le prénom doit être valide : pas de caractères spéciaux (accents
					autorisés)
				</span>
			</div>
		</div>
		<div *ngIf="form.contains('lastName')" class="col-12 col-lg">
			<label for="inputLastName" class="form-label fw-bold">Nom</label>
			<input
				autocomplete="off"
				type="text"
				class="form-control"
				id="inputLastName"
				name="lastName"
				formControlName="lastName"
				[ngClass]="{
					'is-invalid': lastName.invalid,
					'is-valid': lastName.dirty && lastName.valid
				}"
			/>
			<div *ngIf="lastName.invalid" class="invalid-feedback">
				<span *ngIf="lastName.errors?.required">Un nom est requis</span>
				<span *ngIf="lastName.errors?.maxlength"
					>Le nom ne doit pas dépasser {{ MAX_NAME_CHAR }} caractères</span
				>
				<span *ngIf="lastName.errors?.pattern"
					>Le nom doit être valide : pas de caractères spéciaux (accents
					autorisés)
				</span>
			</div>
		</div>
	</div>

	<div class="row my-4">
		<div class="col-12 col-lg">
			<label for="email" class="form-label fw-bold">Email</label>
			<input
				class="form-control"
				id="email"
				name="email"
				formControlName="email"
				[ngClass]="{
					'is-invalid': form.errors?.emailRequired
						? true
						: false || !email.valid,
					'is-valid':
						email.dirty && email.valid && !form.errors?.emailRequired
							? true
							: false
				}"
			/>
		</div>
		<div *ngIf="form.contains('telephone')" class="col-12 col-lg-6">
			<label for="telephone" class="form-label fw-bold">Numéro de téléphone</label>
			<input
				autocomplete="off"
				type="text"
				class="form-control"
				id="telephone"
				name="telephone"
				formControlName="telephone"
				[ngClass]="{
					'is-invalid': telephone.invalid,
					'is-valid': telephone.dirty && telephone.valid
				}"
			/>
			<div *ngIf="telephone.invalid" class="invalid-feedback">
				<span *ngIf="telephone.errors?.pattern"
					>Veuillez saisir un numéro de téléphone correct : 0123456789</span
				>
			</div>
		</div>
	</div>

	<div class="row my-4">
		<!-- <div class="col-12 col-lg-6">
			<label for="inputAddresse" class="form-label theme-main-color fw-bold"
				>Adresse</label
			>
			<input
				autocomplete="off"
				type="text"
				class="form-control"
				id="inputAddresse"
				name="address"
				(typeaheadOnSelect)="onAddressSelect($event)"
				(keyup)="selectedAddressKeyUp($event.target)"
				[typeahead]="addressList"
				[typeaheadAsync]="true"
				typeaheadOptionField="displayName"
				(typeaheadLoading)="changeTypeaheadLoading($event)"
				formControlName="address"
				[ngClass]="{
					'is-invalid':
						address.invalid ||
						(address.dirty &&
							!(isAddressDefault.value || isAddressSelected.value)),
					'is-valid': address.dirty && address.valid && isAddressSelected.value
				}"
			/>
		</div> -->
		<div *ngIf="form.contains('username')" class="col-12 col-lg">
			<label for="username" class="form-label fw-bold"
				>Nom d'utilisateur</label
			>
			<input
				autocomplete="off"
				type="text"
				class="form-control"
				id="inputUsername"
				name="username"
				formControlName="username"
				[ngClass]="{
					'is-invalid': username.invalid,
					'is-valid': username.dirty && username.valid
				}"
			/>
		</div>
	</div>

	<div class="row my-4">
		<div *ngIf="this.nomStructureActive" class="col-12 col-lg">
			<label for="nomStructure" class="form-label fw-bold"
				>Nom de la structure</label
			>
			<input
				autocomplete="off"
				type="text"
				class="form-control"
				id="nomStructure"
				name="nomStructure"
				formControlName="nomStructure"
				[ngClass]="{
					'is-invalid': nomStructure.invalid,
					'is-valid': nomStructure.dirty && nomStructure.valid
				}"
			/>
		</div>
		<div *ngIf="this.typeStructureActive" class="col-12 col-lg">
			<label for="typeStructure" class="form-label fw-bold"
				>Type de structure</label
			>
			<select
				id="typeStructure"
				class="form-select"
				name="typeStructure"
				formControlName="typeStructure"
				>
				<option *ngFor="let typeStructure of listTypeStructure" value="{{ typeStructure.id }}">
					{{ typeStructure.name}}
				</option>
			</select>
		</div>
	</div>
	<div class="row my-4">
		<div *ngIf="this.emailStructureActive" class="col-12 col-lg">
			<label for="emailStructure" class="form-label fw-bold"
				>Email de la structure</label
			>
			<input
				autocomplete="off"
				type="text"
				class="form-control"
				id="emailStructure"
				name="emailStructure"
				formControlName="emailStructure"
				[ngClass]="{
					'is-invalid': emailStructure.invalid,
					'is-valid': emailStructure.dirty && emailStructure.valid
				}"
			/>
		</div>
		<div *ngIf="this.phoneStructureActive" class="col-12 col-lg-6">
			<label for="phoneStructure" class="form-label fw-bold">Numéro de téléphone de la structure</label>
			<input
				autocomplete="off"
				type="text"
				class="form-control"
				id="phoneStructure"
				name="phoneStructure"
				formControlName="phoneStructure"
				[ngClass]="{
					'is-invalid': phoneStructure.invalid,
					'is-valid': phoneStructure.dirty && phoneStructure.valid
				}"
			/>
			<div *ngIf="phoneStructure.invalid" class="invalid-feedback">
				<span *ngIf="phoneStructure.errors?.pattern"
					>Veuillez saisir un numéro de téléphone correct : 0123456789</span
				>
			</div>
		</div>
	</div>

	<div class="row my-4">
		<div *ngIf="this.addressStructureActive" class="col-12 col-lg">
			<label for="inputAddressStructure" class="form-label fw-bold"
				>Adresse de la structure</label
			>
			<input
				autocomplete="off"
				type="text"
				class="form-control"
				id="inputAddressStructure"
				name="addressStructure"
				(typeaheadOnSelect)="onAddressStructureSelect($event)"
				(keyup)="selectedAddressStructureKeyUp($event.target)"
				[typeahead]="addressList"
				[typeaheadAsync]="true"
				typeaheadOptionField="displayName"
				(typeaheadLoading)="changeTypeaheadLoading($event)"
				formControlName="addressStructure"
				[ngClass]="{
					'is-invalid':
					addressStructure.invalid ||
						(addressStructure.dirty &&
							!(isAddressStructureDefault.value || isAddressStructureSelected.value)),
					'is-valid': addressStructure.dirty && addressStructure.valid && isAddressStructureSelected.value
				}"
			/>
		</div>
	</div>

	<div class="row my-4">
		<label for="expertises" class="form-label fw-bold">Expertise(s)</label>
		<div class="row">
			<div
				class="col-md-4 check"
				*ngFor="let expertise of listExpertise | orderBy : 'name' : 'asc'"
			>
				<div *ngIf="expertise.id !== 0">
					<input
						type="checkbox"
						name="{{ expertise.id }}"
						class="form-check-input"
						[value]="expertise"
						[checked]="isExpertiseCheck(expertise)"
						[ngClass]="{
							'theme-main-color-check': isExpertiseCheck(expertise)
						}"
						(change)="updateSelectedExpertise($event, expertise)"
					/>
					<label class="ms-2 form-check-label text-dark">
						{{ expertise.name }}
					</label>
				</div>
			</div>
		</div>
	</div>

	<div *ngIf="isAddForm" class="row my-5">
		<div class="d-flex justify-content-end">
			<button
				class="btn theme-main-color-button mx-3 px-3"
				type="button"
				(click)="hideModal.emit()"
			>
				Retour
			</button>
			<button
				[disabled]="!form.valid || isValidateButtonClicked.value"
				class="btn theme-green-button"
				type="submit"
				form="form"
			>
				<i class="bi bi-save-fill px-1" aria-hidden="true"></i>Sauvegarder
			</button>
		</div>
	</div>
</form>
